export default __webpack_public_path__ + "static/media/menu.dfacca4a.svg";